import { CLASSROOM_REPORT_V2_QUESTIONS, CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty } from "helpers/common";
import { numberRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
    switch (currentTab) {
        case 1:
            return object().shape({
                screening_date: date()
                    .nullable()
                    .required('Screening date is required'),
                report_classname: stringRequiredSchema.required("Required"),
                report_total_students: numberRequiredSchema.required("Required"),
                report_grade: stringRequiredSchema.required("Required"),
                report_age_range: stringRequiredSchema.required("Required"),
                school_division: object().shape({
                    label: stringRequiredSchema,
                    value: numberRequiredSchema
                }).required("This field is required"),
                school: object().shape({
                    label: stringRequiredSchema,
                    value: numberRequiredSchema
                }).required("This field is required"),
                teacher: object().shape({
                    label: stringRequiredSchema,
                    value: numberRequiredSchema
                }).required("This field is required"),
                coordinator: object().shape({
                    label: stringRequiredSchema,
                    value: numberRequiredSchema
                }).required("This field is required")
            });
        case 2:

            return object({
                [CLASSROOM_REPORT_V2_QUESTIONS.classroom_information]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                [CLASSROOM_REPORT_V2_QUESTIONS.teacher_concerns]: object({
                    answer: stringRequiredSchema
                }),
            });
        case 3:
            return object().shape({
                observations: array().of(
                    object().shape({
                        notes: stringRequiredSchema,
                        strategy: array().of(
                            object().shape({
                                answers: string()
                                    .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                    .required('This field is required'),
                                // tracker_percentage: numberRequiredSchema
                            })
                        ).min(1, "Atleast 1 strategy is required."),
                        obs_date: date()
                            .required('Observation date is required'),
                    })
                ).min(1, "Atleast 1 observation is required."),
            });

        case 4:
            return object().shape({
                recommendation: array().of(
                    object().shape({
                        answers: string()
                            .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                            .required('This field is required'),
                    })
                ),
            });
        default:
            return object();
    }
}

export default getValidationSchema;